import { useRef, useState } from 'react';
import * as yup from 'yup';

import { Link, makeStyles, TextField, Typography } from '@material-ui/core';

import AsyncActionButton from 'Components/AsyncActionButton';
import { LogoMark } from 'Components/decor/Logo';
import { urls } from 'Utils/AppUrls';
import { legacyPost } from 'Utils/rest.js';

const useStyles = makeStyles((theme) => ({
  prompt: {
    margin: theme.spacing(2, 0),
  },
  field: {
    margin: theme.spacing(1, 0, 0, 0),
  },
  error: {
    color: theme.palette.error.main,
  },
}));

const validationSchema = yup.object().shape({
  email: yup.string().required('Email is required'),
  password: yup.string().required('Password is required'),
});
const LoginForm = ({ showLogout }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const classes = useStyles();
  const emailRef = useRef();
  const passwordRef = useRef();

  // Check for email in query params
  const [defaultEmail, setDefaultEmail] = useState(() => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('email') || '';
  });

  const onSubmit = () => {
    const form = new FormData();
    const email = emailRef.current.value;
    const password = passwordRef.current.value;

    if (email == '') {
      setError('Email must not be blank.');
      return;
    }

    if (password == '') {
      setError('Password must not be blank.');
      return;
    }

    form.append('username', email);
    form.append('password', password);
    form.append('remember-me', true);
    setLoading(true);

    legacyPost('/login', form)
      .then((response) => {
        setLoading(true);
        try {
          console.log('Response', response);
          console.log('Response data', response?.data);
          console.log('Response data redirectUrl', response?.data?.redirectUrl);
        } catch (e) {
          console.error(e);
          // Suppress error and continue
        }
        window.location = response?.data?.redirectUrl || '/dashboard';
      })
      .catch((error) => {
        setLoading(false);
        if (error.response.status == 401) {
          setError(
            'The email or password you have entered is invalid, try again.',
          );
        } else {
          setError('An unexpected error happened: ' + error.response.data);
        }
      });
  };

  const handleKey = (e) => {
    if (e.key == 'Enter') {
      onSubmit();
    }
  };

  /**
   * Reason why we use refs: browser autofill will not play
   * nice with React, putting value into the inputs without
   * triggering onChange... which leads us to fail validation.
   */

  return (
    <form className='login-form' onSubmit={onSubmit}>
      <LogoMark size='small' />
      <Typography variant='h2' className={classes.prompt}>
        Log in to Materio
      </Typography>
      <TextField
        className={classes.field}
        fullWidth
        id='email'
        name='email'
        placeholder='name@example.com'
        autoFocus={!defaultEmail}
        label='Email'
        inputRef={emailRef}
        defaultValue={defaultEmail}
      />
      <TextField
        className={classes.field}
        fullWidth
        autoFocus={!!defaultEmail}
        id='password'
        name='password'
        label='Password'
        type='password'
        inputRef={passwordRef}
        onKeyPress={handleKey}
      />
      <br />
      <div style={{ width: '100%' }}>
        {error && <p className={classes.error}>{error}</p>}
        <AsyncActionButton
          fullWidth
          action={onSubmit}
          loading={loading}
          size='large'
        >
          Log in
        </AsyncActionButton>
      </div>
      <br />
      <Link underline='always' href={urls.forgotPassword()}>
        Forgot password?
      </Link>
      <br />
      <div>
        Don&apos;t have an account?{' '}
        <Link underline='always' href={urls.register()}>
          Sign up here
        </Link>
      </div>
    </form>
  );
};

export default LoginForm;
